import Home01 from "./Home01";
import BookDetails from "./BookDetails";
import ReadBook from "./ReadBook";
import Presentation from "./Presentation";
import Resources from "./Resources";

const routes = [
  { path: "/", component: <Home01 /> },
  { path: "/book-details", component: <BookDetails /> },
  { path: "/read-book", component: <ReadBook /> },
  { path: "/presentation", component: <Presentation /> },
  { path: "/more-about", component: <Resources /> },
];

export default routes;
